<div *blockUI="'section-block'">
  <button type="button" class="btn btn-success mb-1" rippleEffect (click)="createPdf()">Pdf Ekle</button>

  <div class="row">
    <div class="col-12 col-sm-12 col-md-6 col-xl-4" *ngFor="let item of rows">
      <div class="card mb-4">
        <div class="card-body">
          <h4 class="card-title">{{item.pdfTitle}}</h4>
          <div class="card-subtitle text-muted mb-1">{{item.title}}</div>
          <p class="card-text">
            {{item.createdAt | date : 'dd/MM/yyyy'}}
          </p>
          <div class="row">
            <button type="button" class="btn btn-icon btn-flat-info" rippleEffect (click)="generatePDF(item.id)">
              <span [data-feather]="'eye'"></span></button>
            <a href="#/admin/update-pdf/{{item.id}}"><button type="button" class="btn btn-icon btn-flat-warning"
                rippleEffect>
                <span [data-feather]="'edit'"></span></button></a>
            <button type="button" class="btn btn-icon btn-flat-danger" rippleEffect appDelete controller="pdfs"
              [id]="item.id" (callback)="getAllPdfList(0,5)">
              <span [data-feather]="'trash'"></span></button>

          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Paginator Section -->
  <div class="row">
    <div class="col-12 d-flex justify-content-between">
      <p>Toplam Veri <strong>{{totalCount}}</strong></p>
      <ngb-pagination [collectionSize]="totalCount" [(page)]="pageBasic" [pageSize]="selectedSize"
        [directionLinks]="true" (pageChange)="onPageChange($event)">
      </ngb-pagination>
    </div>
  </div>
</div>